// @flow strict

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';

import { MicroFrontEnds } from '../../microfrontendURIs';

import MicroFrontend from '..';
import { ContainerCentered } from 'styles/common';
import ErrorMessage from 'components/ErrorMessage';

import type { IntlType } from 'types';

import type { ImmutableUser } from 'services/Authentication/types';
import { selectUser, selectUserTimezone } from 'services/Authentication/selectors';
import { isSolvExtractUser } from 'utils/authentication';

type Props = {
    intl: IntlType,
    user: ImmutableUser,
    userTimezone: string,
};

type State = {
    isUnLoadable: boolean,
};

class GeoDashboard extends React.PureComponent<Props, State> {
    state = {
        isUnLoadable: false,
    };

    static getHost = () => {
        return MicroFrontEnds.geoDashboard;
    };

    static getUniqueName = () => {
        return 'GeoDashboardMFE';
    };

    getMountProps = () => {
        return {
            locale: this.props.intl.locale.toUpperCase(),
            userTimezone: this.props.userTimezone,
        };
    };

    onError = () => {
        this.setState({ isUnLoadable: true });
    };

    render() {
        const isAllowed = isSolvExtractUser(this.props.user);
        if (!isAllowed) {
            return (
                <ContainerCentered>
                    <ErrorMessage
                        errorMessage={this.props.intl.formatMessage({
                            id: 'views.GeoDashboardMFE.userNotAllowed',
                        })}
                    />
                </ContainerCentered>
            );
        }
        if (this.state.isUnLoadable) {
            return (
                <ContainerCentered>
                    <ErrorMessage
                        errorMessage={this.props.intl.formatMessage({
                            id: 'views.GeoDashboardMFE.anErrorOccurredDuringLoad',
                        })}
                    />
                </ContainerCentered>
            );
        }
        return (
            <MicroFrontend
                name={GeoDashboard.getUniqueName()}
                host={GeoDashboard.getHost()}
                mountedMicroFrontendProps={this.getMountProps()}
                onError={this.onError}
                mfeIsInFullScreen
            />
        );
    }
}

const mapStateToProps = () =>
    createStructuredSelector({
        user: selectUser(),
        userTimezone: selectUserTimezone(),
    });

export default connect(mapStateToProps)(injectIntl(GeoDashboard));
